import { api } from '@/galaxy-cruise/api'
import { IPresent202201 } from '@/galaxy-cruise/api_interface'
import { loginGuard } from '@/galaxy-cruise/utils'
import { Vue, Component } from 'vue-property-decorator'

@Component({
  beforeRouteEnter: loginGuard,
})
export default class extends Vue {
  home() {
    this.$router.push('/')
  }

  validateAlways = false
  alreadyApplied = false
  achievement = 0
  required = 0

  name = ''
  get nameErrors() {
    return [
      this.name.length === 0 && this.$t('cannot_be_blank'),
    ].filter((e) => e)
  }

  zipCode = ''
  get zipCodeErrors() {
    return [
      this.zipCode.length === 0 && this.$t('cannot_be_blank'),
    ].filter((e) => e)
  }

  address1 = ''
  get address1Errors() {
    return [
      this.address1.length === 0 && this.$t('cannot_be_blank'),
    ].filter((e) => e)
  }

  address2 = ''
  get address2Errors() {
    return [
      this.address2.length === 0 && this.$t('cannot_be_blank'),
    ].filter((e) => e)
  }

  address3 = ''

  confirm = false
  get confirmErrors() {
    return [
      (this.confirm === false && this.$t('check')),
    ].filter((e) => e)
  }

  countryCode = 392
  get countryCodeErrors() {
    return [
      (this.countryCode === -1 && this.$t('cannot_be_blank')),
    ].filter((e) => e)
  }

  message = ''

  mounted() {
    //@ts-ignore
    this.$refs.name && this.$refs.name.focus()
    this.reload()
  }

  get achievementErrors() {
    const { required } = this
    return [
      (this.achievement < this.required && this.$t('too_few_galaxies', { required })),
    ].filter((e) => e)
  }

  get ok() {
    return this.nameErrors.length +
      this.zipCodeErrors.length +
      this.address1Errors.length +
      this.address2Errors.length +
      this.confirmErrors.length +
      this.achievementErrors.length == 0
  }

  async reload() {
    const { data: { achievement, item, required } } = await api.default.get<{ achievement: number, required: number, item?: IPresent202201 }>('../api/v1/present202201')
    this.required = required
    this.achievement = achievement
    if (achievement < required) {
      alert(this.$t('not_fullfilled', { required }))
    }
    this.alreadyApplied = !!item
    if (item) {
      this.name = item.name
      this.zipCode = item.zip_code
      this.countryCode = item.country_code
      this.address1 = item.address1
      this.address2 = item.address2
      this.address3 = item.address3
      this.message = item.message
    }
  }

  async submit() {
    if (!this.ok) {
      (this.$refs.dialog as any).shake(() => this.validateAlways = true)
      return
    }
    const item: IPresent202201 = {
      name: this.name,
      zip_code: this.zipCode,
      address1: this.address1,
      address2: this.address2,
      address3: this.address3,
      country_code: this.countryCode,
      message: this.message,
    }
    await api.default.post('../api/v1/present202201', { item })
    alert(this.alreadyApplied ? this.$t('updated') : this.$t('applied'))
    await this.reload()
  }

  async cancel() {
    await api.default.delete('../api/v1/present202201')
    alert(this.$t('cancelled'))
    await this.reload()
  }
}